import { Colors } from './Colors';

const tags = {
    // bold: {
    //     fontFamily: Fonts.InterBold,
    // },
    bullet: {
        wrap: {
            mode: 'word',
            width: 700,
        },
        x: 20,
    },
    georgiaPurpleItalic: {
        color: Colors.Text.Purple,
        fontFamily: 'GeorgiaItalic',
    },
    lightBlueItalic: {
        color: Colors.Text.LightBlue,
    },
    montserratBold: {
        fontFamily:
            'MontserratBold, "NotoSansJP-Bold", "NotoSansArabic-Bold", "NotoSansThai-Bold", sans-serif',
    },
};

export { tags };
